import type { LucideIcon } from "lucide-react";
import * as React from "react";

import { Button } from "./Button";
import { cn } from "../lib/utils";
import type { VariantProps } from "class-variance-authority";
import { buttonVariants } from "./Button";

interface IconButtonProps
  extends React.ComponentProps<"button">, VariantProps<typeof buttonVariants> {
  icon: LucideIcon;
  asChild?: boolean;
  isActive?: boolean;
}

function IconButton({
  icon: Icon,
  className,
  variant = "ghost",
  size = "icon",
  isActive,
  ...props
}: IconButtonProps): React.JSX.Element {
  return (
    <Button
      variant={variant}
      size={size}
      data-active={isActive}
      className={cn(isActive && "bg-accent text-accent-foreground", className)}
      {...props}
    >
      <Icon />
    </Button>
  );
}

export { IconButton };
